import { useReadContract } from 'wagmi'
import { BaseVibeAbi } from '../utils/BaseVibeAbi'
import { CONTRACT_ADDRESS } from '../utils/constants'

/**
 * Hook to track and manage voting streak from on-chain data
 * @param address - User's wallet address
 */
export function useStreak(address: string | undefined) {
  // Read streak data from the smart contract
  const { data: streakData, refetch } = useReadContract({
    address: CONTRACT_ADDRESS as `0x${string}`,
    abi: BaseVibeAbi,
    functionName: 'getUserStreak',
    args: address ? [address as `0x${string}`] : undefined,
    query: {
      enabled: !!address && CONTRACT_ADDRESS !== '0x0000000000000000000000000000000000000000',
      refetchInterval: 30000, // Refetch every 30 seconds
    },
  })

  // Extract streak from contract data
  // Contract returns: [currentStreak, lastVoteDate (dateKey), longestStreak]
  const streak = streakData ? Number(streakData[0]) : 0

  /**
   * Update streak - now handled automatically by the contract
   * This function is kept for API compatibility but doesn't need to do anything
   * The contract updates the streak automatically when vote() is called
   */
  const updateStreak = () => {
    // Streak is updated automatically by the contract during vote()
    // No action needed here, but we keep the function for backward compatibility
  }

  /**
   * Refresh streak data from the contract
   */
  const refreshStreak = async () => {
    await refetch()
  }

  return {
    streak,
    updateStreak,
    refreshStreak,
  }
}

